import React, { Component } from 'react'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'hljd'
import Style from './style.module.less'
import { inject, observer } from 'mobx-react'

@inject('store')
@observer
export default class extends Component {
  getCompareStr = num => {
    if (/^-?[0-9]+(.[0-9]+)?$/.test(num)) {
      if (+num >= 0) {
        return (
          <p className={`${Style.desc} ${Style.green}`}>{`较上一场+${num}%`}</p>
        )
      } else if (+num < 0) {
        return (
          <p className={`${Style.desc} ${Style.red}`}>{`较上一场${num}%`}</p>
        )
      }
    }

    return ''
  }
  render() {
    const {
      store: { consoleStatistical = {} }
    } = this.props
    const {
      watchCount,
      watchCountProportion,
      messageNum,
      messageNumProportion,
      avgTime,
      avgTimeProportion,
      getRate,
      getRateProportion
    } = consoleStatistical

    return Object.keys(consoleStatistical).length > 0 ? (
      <div className={`${Style.videoData} ${Style.border}`}>
        <p className={Style.title}>
          直播数据
          <a
            href="https://www.yuque.com/zhiboxiaozhushou/tihy4t/rnitlp"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#FF801A', fontSize: 14, marginLeft: '10px' }}
          >
            怎么提升数据，点击这里查看攻略～
          </a>
        </p>
        <div className={Style.flex}>
          <div className={Style.flexItem}>
            <p className={Style.type}>
              围观数
              <Tooltip title="截止到当前时间进入直播间的总数">
                <QuestionCircleOutlined />
              </Tooltip>
            </p>
            <p className={Style.count}>{watchCount}</p>
            {this.getCompareStr(watchCountProportion)}
          </div>
          <div className={Style.flexItem}>
            <p className={Style.type}>
              人均观看时长
              <Tooltip title="截止到昨天凌晨，进入直播间的客户的人均观看时长，单位为秒">
                <QuestionCircleOutlined />
              </Tooltip>
            </p>
            <p className={Style.count}>{avgTime}</p>
            {this.getCompareStr(avgTimeProportion)}
          </div>
          <div className={Style.flexItem}>
            <p className={Style.type}>
              直播互动数
              <Tooltip title="截止到直播结束（直播未结束即截止到当前时间），直播间客户发表弹幕的次数">
                <QuestionCircleOutlined />
              </Tooltip>
            </p>
            <p className={Style.count}>{messageNum}</p>
            {this.getCompareStr(messageNumProportion)}
          </div>
          <div className={Style.flexItem}>
            <p className={Style.type}>
              直播转化率
              <Tooltip title="进入直播间观看直播后转化的用户占总观看人数比值">
                <QuestionCircleOutlined />
              </Tooltip>
            </p>
            <p className={Style.count}>
              {getRate ? getRate.toFixed(2) + '%' : '--'}
            </p>
            {this.getCompareStr(getRateProportion)}
          </div>
        </div>
      </div>
    ) : null
  }
}
